import type { Icon } from '#lib/types/icons.js';
import { DateTime } from 'luxon';
import { writable } from 'svelte/store';

export const toastStore = writable<Toast[]>([]);

// define Toast interface
export interface Toast {
	text: string;
	icon?: Icon;
	bgColor?: 'success' | 'error' | 'warning' | undefined;
	goto?: string | (() => void);
	fixed?: boolean;
	date?: number;
	timeout?: NodeJS.Timeout;
}

type ToastOptions = Partial<Omit<Toast, 'text' | 'bgColor'>>;

export function showToast(toast: Toast) {
	toast.date = DateTime.now().toMillis() + Math.random();
	toastStore.update((value) => {
		return [...value, toast];
	});
}

export function toastError(text: string, options?: ToastOptions) {
	showToast({ text, icon: 'bang', bgColor: 'error', ...options });
}

export function toastSuccess(text: string, options?: ToastOptions) {
	showToast({ text, icon: 'Check', bgColor: 'success', ...options });
}

export function toastWarning(text: string, options?: ToastOptions) {
	showToast({ text, icon: 'bang', bgColor: 'warning', ...options });
}
